import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-horarios',
  templateUrl: './modal-horarios.component.html',
  styleUrls: ['./modal-horarios.component.scss']
})
export class ModalHorariosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
